export const US_STATES = [
  'Alabama','Alaska','Arizona','Arkansas','California','Colorado','Connecticut',
  'Delaware','Florida','Georgia','Hawaii','Idaho','Illinois','Indiana','Iowa',
  'Kansas','Kentucky','Louisiana','Maine','Maryland','Massachusetts','Michigan',
  'Minnesota','Mississippi','Missouri','Montana','Nebraska','Nebraska',
  'New Hampshire','New Jersey','New Mexico','New York','North Carolina',
  'North Dakota','Ohio','Oklahoma','Oregon','Pennsylvania','Rhode Island',
  'South Carolina','South Dakota','Tennessee','Texas','Utah','Vermont',
  'Virginia','Washington','West Virginia','Wisconsin','Wyoming',
];

export const PROPERTY_TYPES = [
  { label: 'Single-Family Home', icon: 'Home' },
  { label: 'Condo / Townhouse',  icon: 'Building2' },
  { label: 'Mobile Home',        icon: 'Warehouse' },
  { label: 'Multi-Family',       icon: 'Hotel' },
];

export const COVERAGE_ITEMS = [
  'Air Conditioning','Heating System','Plumbing System','Electrical System',
  'Water Heater','Refrigerator','Dishwasher','Washer & Dryer',
  'Oven / Range','Garbage Disposal','Garage Door Opener','Ceiling Fans',
];

export const ADD_ONS = [
  'Pool & Spa','Roof Leak Repair','Well Pump',
  'Septic System','Guest Unit','Electronics Protection',
];

export const PLANS = [
  {
    name: 'Systems',
    popular: false,
    desc: 'Essential coverage for your home\'s major systems.',
    features: [
      { text: 'HVAC (heating & cooling)', included: true },
      { text: 'Plumbing system',          included: true },
      { text: 'Electrical system',        included: true },
      { text: 'Water heater',             included: true },
      { text: 'No appliance coverage',    included: false },
      { text: 'No add-on options',        included: false },
    ],
  },
  {
    name: 'Comprehensive',
    popular: true,
    desc: 'Full coverage for systems and all major appliances.',
    features: [
      { text: 'Everything in Systems', included: true },
      { text: 'Refrigerator',          included: true },
      { text: 'Dishwasher',            included: true },
      { text: 'Washer & Dryer',        included: true },
      { text: 'Oven / Range',          included: true },
      { text: 'Add-ons available',     included: true },
    ],
  },
  {
    name: 'Premium',
    popular: false,
    desc: 'Maximum protection with priority service and extras.',
    features: [
      { text: 'Everything in Comprehensive', included: true },
      { text: 'Roof leak repair included',   included: true },
      { text: 'Unlimited AC refrigerant',    included: true },
      { text: 'Enhanced HVAC coverage',      included: true },
      { text: 'All add-ons included',        included: true },
      { text: 'Priority 4-hour dispatch',    included: true },
    ],
  },
];

export const FEATURES = [
  { icon: 'Zap',        bg: '#dbeeff', title: 'Instant online quote',         desc: 'Enter your ZIP and get a full personalized quote in under 3 minutes — no phone call required.' },
  { icon: 'Wrench',     bg: '#d4f5e9', title: 'Fast 24-hour dispatch',        desc: 'Our network of 15,000+ licensed pros responds fast. Emergency calls prioritized within 4 hours.' },
  { icon: 'Shield',     bg: '#fef3d8', title: 'No surprise costs',            desc: 'Pay one fixed service call fee, we cover the rest. No deductibles, no hidden charges, ever.' },
  { icon: 'Home',       bg: '#eee9ff', title: 'Any age, any home',            desc: 'No inspection required. We cover homes of any age, from new builds to century-old classics.' },
  { icon: 'RefreshCw',  bg: '#ffe9e9', title: '30-day workmanship guarantee', desc: 'If a covered repair fails within 30 days, we send a tech back at no additional charge.' },
  { icon: 'Smartphone', bg: '#d4f2f0', title: 'Easy online claims',           desc: 'File a claim in seconds via our app or website. Track your service request status in real time.' },
];

export const COVERAGE_CARDS = [
  {
    icon: 'Thermometer',
    title: 'Heating & Cooling',
    items: ['Central air conditioning','Heat pump','Furnace & heating','Ductwork','Thermostats','Unlimited AC refrigerant (Premium)'],
  },
  {
    icon: 'Droplets',
    title: 'Plumbing',
    items: ['Water lines & drain lines','Toilets & faucets','Sump pump','Built-in jetted tub','Gas lines','Water heater'],
  },
  {
    icon: 'Zap',
    title: 'Electrical',
    items: ['Wiring & panels','Breakers & fuses','Ceiling fans','Garage door opener','Lighting fixtures','Exhaust fans'],
  },
  {
    icon: 'UtensilsCrossed',
    title: 'Kitchen & Laundry',
    items: ['Refrigerator','Built-in dishwasher','Oven, range & cooktop','Built-in microwave','Washer & dryer','Garbage disposal'],
  },
];

export const REVIEWS = [
  { stars: 5, text: '"Our AC died in July — they had a tech out within 24 hours. Covered in full. Saved us a fortune!"', name: 'Linda M.', meta: 'Phoenix, AZ · Verified Buyer', initials: 'LM', bg: '#dbeeff', color: '#185fa5' },
  { stars: 5, text: '"Easiest quote I\'ve ever gotten. Three minutes, no pushy calls. We\'ve been covered for 2 years now."', name: 'James T.', meta: 'Austin, TX · Verified Buyer',  initials: 'JT', bg: '#d4f5e9', color: '#0d7d50' },
  { stars: 4, text: '"The plumbing claim was handled professionally. Minor wait on the tech but great value for money."',   name: 'Sarah K.', meta: 'Atlanta, GA · Verified Buyer', initials: 'SK', bg: '#fef3d8', color: '#854f0b' },
];

export const FAQS = [
  { q: 'What does a home warranty cover?',        a: 'A home warranty covers the repair and replacement of major home systems (HVAC, plumbing, electrical) and appliances when they break down due to normal wear and tear. It does NOT cover damage from accidents, natural disasters, or neglect — that\'s what homeowners insurance is for.' },
  { q: 'How soon does coverage start?',            a: 'Coverage typically begins 30 days after purchase for existing homeowners. If you\'re purchasing at closing, coverage can begin immediately. First-year new construction homes may qualify for immediate coverage.' },
  { q: 'Can I use my own contractor?',             a: 'Some plans allow you to choose your own licensed contractor, while others work within their vetted network. Our Premium plan includes contractor-choice flexibility. Check plan details for specifics.' },
  { q: 'What is a service call fee?',              a: 'A service call fee is a flat fee you pay each time a technician visits your home for a covered repair. You choose your preferred fee level at enrollment to customize your plan to fit your budget.' },
  { q: 'Are pre-existing conditions covered?',     a: 'Most standard plans exclude known pre-existing conditions. However, our Comprehensive and Premium plans cover undetectable pre-existing issues — problems that weren\'t visually diagnosable before coverage began.' },
  { q: 'Is my home too old to qualify?',           a: 'No. We cover homes of any age. No inspection is required for our standard plans, and there\'s no upper age limit on systems or appliances covered.' },
];
